import {commonActions, commonConstants} from '../../actions/commonActions';
import {connect} from 'react-redux';
import Login from '../../components/login/Login'
import {appLogin} from '../../services/AuthService'
import {API_FETCH} from '../../services/FetchService'
import {userConstants} from "../../constants/userConstants";
import {alertConstants} from "../../constants/alertConstants";
import jwtDecode from "jwt-decode";

const mapDispatchToProps = dispatch => ({

    onSubmit: (values) => {
        dispatch({type: userConstants.LOGIN_REQUEST});
        API_FETCH.post('auth/sign_in', {
            username: values.username,
            passwd: values.password
        }).then(res => {
            if (res.data && res.data.access_token) {
                var userData = jwtDecode(res.data.access_token);
                if (!['ADMIN', 'SUPERADMIN', 'OPERATOR'].includes(userData['rl'])) {
                    dispatch({type: userConstants.LOGIN_FAILURE});
                    dispatch({
                        type: alertConstants.ERROR,
                        message: 'شما اجازه ورود به پنل را ندارید'
                    })
                    return;
                }
                appLogin(res.data.access_token,userData);
                dispatch({type: userConstants.LOGIN_SUCCESS});
                window.location.reload();
                dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/'});
            } else if (res.data && res.status === 401) {
                dispatch({type: userConstants.LOGIN_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'نام کاربری یا رمز عبور اشتباه است'
                })
            }
        }).catch(error => {
            dispatch({type: userConstants.LOGIN_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'نام کاربری یا رمز عبور اشتباه است'
            })
        });

    },


    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },

});

const mapStateToProps = state => ({
    alert: state.alert,
    auth: state.auth,
    common: state.common
})

export default connect(mapStateToProps, mapDispatchToProps)(Login);
